import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import LoaderCircle from '@/components/LoaderCircle'

import dayjs from 'dayjs'
import HeaderSearchBarTurnsDebts from './components/headerSearchBarTurnsDebts'
import TableTurnsDebts from './components/tableTurnsDebts'
import TotalsTurnsDebts from './components/totalsTurnsDebts'

import s from '../../styles.module.scss'

const TurnsDebtsTab = ({ directionOfAnimation }) => {
  const [inputSearch, setInputSearch] = useState('')
  const [loadingPatients, setLoadingPatients] = useState(false)
  const [patientValue, setPatientValue] = useState(null)
  const [startDate, setStartDate] = useState(dayjs(new Date()).startOf('week').format())
  const [finishDate, setFinishDate] = useState(dayjs(new Date()).endOf('week').format())

  const { turnsDebts, isLoading } = useSelector((state) => state.debts)

  return (
    <div className={directionOfAnimation}>
      <HeaderSearchBarTurnsDebts
        inputSearch={inputSearch}
        setInputSearch={setInputSearch}
        loadingPatients={loadingPatients}
        setLoadingPatients={setLoadingPatients}
        patientValue={patientValue}
        setPatientValue={setPatientValue}
        startDate={startDate}
        setStartDate={setStartDate}
        finishDate={finishDate}
        setFinishDate={setFinishDate}
      />
      {isLoading ? (
        <LoaderCircle size={50} />
      ) : turnsDebts?.length === 0 ? (
        <p className={s.noItems}>No hay items para las fechas solicitadas</p>
      ) : (
        <div>
          <TableTurnsDebts patientValue={patientValue} startDate={startDate} finishDate={finishDate} />
          <TotalsTurnsDebts finishDate={finishDate} />
        </div>
      )}
    </div>
  )
}

export default TurnsDebtsTab
